// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthNavBar_wrapper__eZdNp","ani":"AuthNavBar_ani__-0uVB"};